"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const rc_slider_1 = __importDefault(require("rc-slider"));
const styles_1 = require("./styles");
const Slider = props => {
  const {
    type,
    min,
    max,
    marks,
    step,
    value,
    onChange = () => {},
    onAfterChange,
    isDisabled,
    trackBg,
    handleBorder,
    handleBg,
    railBg,
    pushable
  } = props;
  const [minValue, maxValue] = value || [];
  const handleChange = newValue => {
    if (typeof newValue === 'number') {
      onChange([newValue]);
      return;
    }
    onChange(newValue);
  };
  const handleOnAfterChange = newValue => {
    if (typeof newValue === 'number') {
      onAfterChange([newValue]);
      return;
    }
    onAfterChange(newValue);
  };
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: (0, jsx_runtime_1.jsxs)(styles_1.SliderContainer, {
      trackBg: trackBg,
      handleBorder: handleBorder,
      handleBg: handleBg,
      railBg: railBg,
      withoutMarks: !marks,
      children: [type === 'slider' && (0, jsx_runtime_1.jsx)(rc_slider_1.default, {
        disabled: isDisabled,
        value: minValue,
        min: min,
        max: max,
        step: step,
        marks: marks,
        onChange: handleChange,
        onAfterChange: handleOnAfterChange
      }), type === 'range' && (0, jsx_runtime_1.jsx)(rc_slider_1.default, {
        range: true,
        disabled: isDisabled,
        value: [minValue, maxValue],
        min: min,
        max: max,
        step: step,
        marks: marks,
        allowCross: false,
        onChange: handleChange,
        onAfterChange: handleOnAfterChange,
        pushable: pushable
      })]
    })
  });
};
exports.default = Slider;